import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Constants
import { LONG_HUMAN_DATE_FORMAT } from 'constants';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';

// Components
export default class RelativeTime extends React.Component {
  static propTypes ={
    date: PropTypes.any,
    startDate: PropTypes.string,
    locale: PropTypes.string,
    title: PropTypes.node
  };

  static defaultProps = {
    locale: 'en-short'
  };

  constructor() {
    super();

    this.state = {};

    this.setTimeout = this.setTimeout.bind(this);
  }

  componentWillMount() {
    this.setTimeout();
  }

  componentWillUpdate() {
    this.setTimeout();
  }
  
  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  setTimeout() {
    const { date } = this.props;
    const seconds = Math.abs(moment(date).diff(moment(), 'seconds'));

    // Clear the other timeout that might be in progress
    window.clearTimeout(this.timeout);

    // If we are under a minute refresh every second
    if (seconds < 60) {
      this.timeout = window.setTimeout(() => this.forceUpdate(), 1000);
      return;
    }

    // If we are under an hour refresh every minute
    if (seconds < 60 * 60) {
      this.timeout = window.setTimeout(() => this.forceUpdate(), 60 * 1000);
      return;
    }

    // If we are under a day refresh every hour
    if (seconds < 60 * 60 * 24) {
      this.timeout = window.setTimeout(() => this.forceUpdate(), 60 * 60 * 1000);
      return;
    }
  }

  render() {
    const { date, startDate, locale, ...passed } = this.props;
    const title = moment(date).format(LONG_HUMAN_DATE_FORMAT);
    const diff = Math.abs(moment(date).diff(startDate || moment(), 'days'));
    const relative = moment(date).locale(locale).from(startDate || moment(), true);
    const absolute = moment(date).format('M/D');
    const time = startDate || diff <= 7 ? relative : absolute;

    return (
      <Tooltip className="date-tooltip-wrapper" title={title} {...passed}>{time}</Tooltip>
    );
  }
}
